import module from '@app/module'

module.config(($stateProvider, $animateProvider, $translateProvider, $locationProvider, $httpProvider, $compileProvider) => {
  $animateProvider.classNameFilter(/kd-animate/)

  $locationProvider.html5Mode(true)

  $httpProvider.useApplyAsync(true)

  $httpProvider.interceptors.push('KdLoadIndicator')

  $compileProvider.debugInfoEnabled(window.location.hostname === 'localhost')
})



// WEBPACK FOOTER //
// ./src/app/config.js